// import logo from "./logo.svg";
import styles from "./App.module.css";
// import Ace from "./components/Ace";
import React, { useRef, useState } from "react";
import Header from "./components/Header";
import RightPanel from "./components/RightPanel";
import LeftPanel from "./components/LeftPanel";
import RightBar from "./components/RightBar";


import "ace-builds/src-noconflict/mode-latex";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";

import { regexFinderTool } from "./Utils/utils";
import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
// import { getNormalPdfApi } from "./api";
import SplitPane, { SplitPaneLeft, Divider, SplitPaneTop, VerDivider, SplitPaneMiddle, DividerLeft } from "./SplitPane";
import AceFunctional from "./components/AceFunctional";
import Toppanel from "./components/Toppanel";
import FileViewer from "./components/FileViewer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get_all_project_file_Api, get_one_project_Api, getPdfFile } from "./dashboardapi";



function App() {
  const { projectid } = useParams();
  const { file } = useParams();
  const [rightController, setRightController] = useState({
    view: "",
    pdfData: "",
    errorData: "",
    rawData: "",
    scale: 0.2,
    prevScroll: 0,
  });
  const [filename, setFileName] = useState("");
  const [leftController, setLeftController] = useState(true);
  const [pdfviewer, setPdfViewer] = useState(true);
  const [pdfFull, setPdfFull] = useState(false);
  const [parentWidth, setParentWidth] = useState();
  const [childHeight, setChildHeight] = useState();
  const [change, setChange] = useState(false);
  const ace = useRef();
  const pdfContainer = useRef();
  const parentdiv = useRef();
  const childdiv = useRef();
  const [projectFiles, setProjectFiles] = useState([]);
  const leftpanelforsplit = leftController.toString();
  const pdfviewerforsplit = pdfviewer.toString();
  const pdffullforsplit = pdfFull.toString();
  const [projectDetails, setProjectDetails] = useState({})
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();
  const toppanelRef = useRef();
  const [pdfStatus, setPdfStatus] = useState({ loading: false, error: null });
  const bottompanelRef = useRef();
  const [openFiles, setOpenFiles] = useState([]);

  // useEffect(() => {
  //   console.log(pathname);
  // })
  //MARK:filetype
  // const fileType= file?.split(".").pop();

  //console.log(file);
  const toggleLeftPanel = () =>
    setLeftController((leftController) => !leftController);

  const togglePDF = () => {
    setPdfViewer(!pdfviewer);
  };

  const toggleEditor = () => {
    setPdfFull(!pdfFull);
  };

  // const [scrollPos, setScrollPos] = useState(0);

  useEffect(() => {
    loadProjectDetails(); //get one project 
  }, [])

  useEffect(() => {
    getProjectFiles();  //get all project files
  }, [projectDetails])

  useEffect(() => {
    if (hash === "#correction" || hash === "#pdf") {
      console.log("the pdf is started to loading");
      // Only load if we don't have pdfData yet or if we aren't already loading
      console.log("the pdf will load or not?", rightController.pdfData, pdfStatus.loading);
      if (!rightController.pdfData && !pdfStatus.loading) {
        console.log("the pdf is loading using the loadpdf");
        loadPdf();
      }
    }
    // }, [projectFiles, hash, rightController.pdfData, pdfStatus.loading]);
  }, [projectFiles, hash, rightController.pdfData]);



  //MARK:loadProjectDetails
  const loadProjectDetails = async () => {
    let result = await get_one_project_Api(projectid);
    try {
      if (result.data) {
        setProjectDetails(result.data);
        // console.log(result.data);
      } else {
        let error = result.error.message || "An error Occurred"
        toast({
          title: error,
          status: "error",
          duration: 2000,
          isClosable: "true",

        })
      }
    } catch (error) {
      toast({
        title: error,
        status: "error",
        duration: 2000,
        isClosable: "true",
      })
    }
  }

  // useEffect(() => {
  //   if (!Array.isArray(projectFiles)) {
  //   }
  // }, [projectFiles, navigate]);

  //MARK:getProjectFiles
  const getProjectFiles = async () => {
    try {
      let result = await get_all_project_file_Api(projectid);
      if (result.data) {
        setProjectFiles(result.data);
        console.log(result.data);

        if (!Array.isArray(result.data) || result.data.length === 0) {
          navigate("/dashboard/myprojects", { state: { toastMessage: "The requested project does not exist here" } });

        }
      }
      else {
        let error = result.error.message || "An error Occurred";
        toast({
          title: error,
          status: "error",
          duration: 2000,
          isClosable: "true",

        });
      }
    } catch (error) {
      toast({
        title: error,
        status: "error",
        duration: 2000,
        isClosable: "true",

      })
    }
  }

  const toast = useToast();

  useEffect(() => {
    let fullwidth = parentdiv.current.getBoundingClientRect().width;
    setParentWidth(fullwidth);
    let fullheight = childdiv.current.getBoundingClientRect().height;
    setChildHeight(fullheight);
  }, []);

  const handlePdfScroll = (scrollTop) => {
    if (pdfStatus.loading) {
      return;
    }

    if (scrollTop > 10) {
      setRightController(prev => ({
        ...prev,
        prevScroll: scrollTop
      }));
    }
  };

  //MARK:load -filter
  const loadPdf = async () => {
    if (!file || !file.toLowerCase().endsWith(".tex")) {
      return;
    }
    if (projectFiles.length === 0) {
      return
    }
    //MARK:load pdf
    // const loadPdf = async () => {
    //   if (file.endsWith('.txt')) {
    //      console.log("Skipping PDF load for .txt file");
    //      return;}
    //   if (projectFiles.length === 0) {
    //     return;
    //   }
    setPdfStatus({ loading: true, error: null });
    let curFileObj = Array.isArray(projectFiles) ? projectFiles.filter(e => e.name === file)[0] : navigate("/dashboard/myprojects");
    var result = await getPdfFile(projectid, curFileObj?.file_uuid);
    console.log("the current result of the pdf is :");
    if (result.data) {
      setRightController((prevState) => ({
        ...prevState,
        pdfData: "data:application/pdf;base64," + result.data.pdf,
      }));
    } else {
      setPdfStatus({ loading: false, error: "Problem loading PDF" });
    }
  };

  const processTools = function (jsonData) {
    var result = regexFinderTool(
      ace.current.editor.session.doc.$lines,
      jsonData
    );

    setRightController((prevState) => ({
      ...prevState,
      view: "error",
      errorData: result,
    }));
    return true;
  };

  // const handleRight = (event) => {
  //   event.preventDefault(); // Prevent browser context menu   
  //   event.stopPropagation();
  //   console.log("hey");
  // };

  // const scrollTo = () => {
  //   let scrollpos = pdfContainer.current.scrollTop;
  //   setScrollPos(scrollpos);
  // };

  // console.log(scrollPos);
  // useEffect(() => {
  //   pdfContainer.current.addEventListener("scroll", scrollTo);

  //   return () => {
  //     pdfContainer.current.removeEventListener("scroll", scrollTo);
  //   };
  // }, []);

  // console.log(projectDetails);

  // console.log(rightController.rawData);


  return (

    <div className={styles.App}>
      <div className={styles.header}>
        <Header
          editorRef={ace}
          projectDetails={projectDetails}
          projectId={projectid}
          projectfiles={projectFiles}
          processTools={processTools}
          pdfContainer={pdfContainer}
          filename={filename}
          current_file={file}
          setRightController={setRightController}
          setPdfStatus={setPdfStatus}
          setChange={setChange}
          change={change}
          control={setRightController}
        />
      </div>

      <div className={styles.container} ref={parentdiv}>
        <SplitPane
          className={styles.split_pane}
          pdffull={pdffullforsplit}
          pdfviewer={pdfviewerforsplit}
          leftcontroller={leftpanelforsplit}
          parentwidth={parentWidth}
        >
          <SplitPaneLeft >
            {<div className={styles.leftcontainer} ref={childdiv}  >


              <LeftPanel
                editorRef={ace}
                current_file={file}
                projectfiles={projectDetails}
                getprojectfiles={getProjectFiles}
                projectid={projectid}
                loadProjectDetails={loadProjectDetails}
                setOpenFiles={setOpenFiles}
                openFiles={openFiles}
              />


            </div>
            }
          </SplitPaneLeft>
          <DividerLeft />
          <SplitPaneMiddle className={styles.leftpane}>
            <div className={styles.eceEditor} id="aceEditorWorkingSpace">
              {/* <Ace
                ref={ace}
                updateCorrections={setCorrections}
                updateQueries={setQueries}
                toast={toast}
                toggleLeftPanel={toggleLeftPanel}
                leftController={leftController}
                togglePDF={togglePDF}
                pdfviewer={pdfviewer}
                pdfFull={pdfFull}
              /> */}

              <AceFunctional
                ref={ace}
                toast={toast}
                toggleLeftPanel={toggleLeftPanel}
                leftController={leftController}
                togglePDF={togglePDF}
                projectDetails={projectDetails}
                setFileName={setFileName}
                pdfviewer={pdfviewer}
                // fileType={fileType}
                pdfFull={pdfFull}
                change={change}
                setChange={setChange}
                showGutter={true}
                {...rightController}
                control={setRightController}
                openFiles={openFiles}
                setOpenFiles={setOpenFiles}

              />

            </div>
          </SplitPaneMiddle>

          <VerDivider />

          <div
            className={styles.pdfViewer}
          >
            <RightPanel
              editorRef={ace}
              {...rightController}
              pdfContainer={pdfContainer}
              toggleEditor={toggleEditor}
              pdfFull={pdfFull}
              pdfStatus={pdfStatus}
              setPdfStatus={setPdfStatus}
              onPdfScroll={handlePdfScroll}
              scale={rightController.scale}
              control={setRightController}
            />
            <div className={styles.RightBar}>
              <RightBar
                toast={toast}
                projectDetails={projectDetails}
                projectId={projectid}
                projectfiles={projectFiles}
                {...rightController}
                control={setRightController}
                current_file={file}
              />
            </div>
          </div>
        </SplitPane>


      </div>
    </div>
  );
}

export default App;
